// extracted by mini-css-extract-plugin
module.exports = {"addToCart":"AddToCartForm_addToCart__Trm9v","submitRow":"AddToCartForm_submitRow__7Z5AA","errorMessage":"AddToCartForm_errorMessage__anals"};